module.exports = __webpack_public_path__ + "img/dev-yellowtrack.244b5231.png";